export default function getResource(label, vars = []) {
    const resources = {
        myBillingAddrIsTheSame: 'My billing address is the same as my shipping address',
        iframeError: 'Trouble connecting to Klarna. Please use a different payment method or try again later.',
        legalNotice: `By clicking “Continue with Klarna,” I am instructing Sephora, at a minimum, to send my order, transaction history, and billing information to Klarna and understand that information will be subject to the Klarna’s <a href='${vars[0]}' target='_blank' rel='noopener noreferrer'>terms</a> and <a href='${vars[1]}' target='_blank' rel='noopener noreferrer'>privacy policy</a> and that I will be redirected to Klarna’s website/app to complete the transaction.`
    };

    return resources[label];
}
